import React, { FC, CSSProperties, ReactNode } from 'react';

export type CustomTooltipProps = {
  message: ReactNode;
  isVisible: boolean;
  style?: CSSProperties;
  className?: string;
  styleChild?: CSSProperties;
  id?: string;
};

const DEFAULT_TOOLTIP_CLASS_NAME =
  'absolute z-50 mt-2 w-96 rounded border border-red-400 bg-site p-2 text-10 text-primary-regular shadow-lg';

const CustomTooltip: FC<CustomTooltipProps> = ({ message, isVisible, style, className, styleChild, id }) => {
  if (!isVisible) return null;

  return (
    <div
      id={id}
      role="tooltip"
      data-testid="atom-tooltip"
      className={className ? className : DEFAULT_TOOLTIP_CLASS_NAME}
      style={style}
    >
      <div
        className="arrow-up"
        style={
          styleChild
            ? styleChild
            : {
                position: 'absolute',
                top: '-5px',
                left: '10px',
                width: 0,
                height: 0,
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderBottom: '5px solid #fc8181',
              }
        }
      ></div>
      {message}
    </div>
  );
};

export default CustomTooltip;
